module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MDAiIGhlaWdodD0iNjAwIj48cGF0aCBmaWxsPSIjMzc3ZTNmIiBkPSJNMCAwaDkwMHY2MDBIMHoiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAxMjBoOTAwdjM2MEgweiIvPjxwYXRoIGZpbGw9IiNiNDBhMmQiIGQ9Ik0wIDE4MGg5MDB2MjQwSDB6Ii8+PHBhdGggZD0iTTQ1MCAxOTEuNDU5bDcwLjUzNCAyMTcuMDgyLTE4NC42NjEtMTM0LjE2NGgyMjguMjU0TDM3OS40NjYgNDA4LjU0MXoiIGZpbGw9IiNlY2M4MWQiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/sur.svg
// module id = zvxl
// module chunks = 0